import { render, staticRenderFns } from "./VxCarousel.vue?vue&type=template&id=d175056c&scoped=true"
import script from "./VxCarousel.vue?vue&type=script&lang=js"
export * from "./VxCarousel.vue?vue&type=script&lang=js"
import style0 from "./VxCarousel.vue?vue&type=style&index=0&id=d175056c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d175056c",
  null
  
)

export default component.exports